import { render, staticRenderFns } from "./FullWidthOfferCard.vue?vue&type=template&id=f10130d0&"
import script from "./FullWidthOfferCard.vue?vue&type=script&lang=js&"
export * from "./FullWidthOfferCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports